import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const registerAsset = (assetUuid) => request.get(`${API_BASE_URL}/blockchain/assets/${assetUuid}/register`)

export default registerAsset